import * as React from 'react';
import styled from 'styled-components';
import { ActionsMenuProps } from './actions-menu.model';
import { ActionsMenuStyle } from './actions-menu.style';
import { useCallback, useState } from 'react';
import classNames from 'classnames';
import { MenuIcon } from './menu-icon/menu-icon.component';

export const ActionsMenu = styled(({ className, actionMenuItems, onActionItemClick, rowData }: ActionsMenuProps) => {
  const [showActionMenu, setShowActionMenu] = useState<boolean>(false);

  const toggleActionMenu = () => setShowActionMenu(!showActionMenu);

  const onActionClick = useCallback((actionId: string) => {
    setShowActionMenu(false);
    onActionItemClick(actionId, rowData);
  }, []);

  return (
    <div className={className}>
      {showActionMenu && <div onClick={toggleActionMenu} className="drop-shadow"></div>}
      {actionMenuItems?.length > 0 && (
        <div className="actions-menu-container">
          <div
            className={classNames('action-icon-container', { 'open-state': showActionMenu })}
            onClick={toggleActionMenu}
          >
            <MenuIcon color={showActionMenu ? '#3156ff' : '#8090B4'} />
          </div>
          {showActionMenu && (
            <div className="actions-menu">
              {actionMenuItems.map((menuItem) => (
                <div
                  className="action-menu-item"
                  key={menuItem.actionId}
                  data-at={`action-menu-item-${menuItem.actionId}`}
                  onClick={() => onActionClick(menuItem.actionId)}
                >
                  {menuItem.icon && <img className="menu-item-icon" src={menuItem.icon} />}
                  <span className="menu-item-text">{menuItem.title}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
})`
  ${ActionsMenuStyle}
`;
